// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.general.location.AdminPracticeLocationDistributionCenterRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminPracticeLocationDistributionCenterRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Location is a distribution center is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isDistributionCenter!: boolean;

	@GandalfArray(Number)
	subscriberLocationIds!: number[] | null;

}
